<template>
    <div>
        <div class="filter-container">
            <!-- 下载 -->
            <div style="margin-right: 10px">
                <span style="font-size: 12px;color:#666;">实际 {{sourceItem.listData.size}} 条(最大下载5万条)</span>
                <el-button size="small" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;" title="下载" :loading="downloadLoading" @click="handleDownload"></el-button>
            </div>

            <!-- table header 筛选 -->
            <div class="filterTableHeader">
                <el-popover width="600" trigger="click">
                    <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
                    <div class="checkboxScrollList">
                        <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
                            <template v-for="(item,index) in tableTheadOptions">
                                <el-checkbox  :key="index" :title="item.label" :label="item" :disabled="index == 0" v-if="item.state == '1'">{{item.label}}</el-checkbox>
                            </template>
                        </el-checkbox-group>
                    </div>
                </el-popover>
            </div>

        </div>

        <!-- 表格 -->
        <el-table class="grayTableTile" :header-cell-style="{fontSize:'12px'}" :data="tableList" border @sort-change="handleAgeSortChange" style="width: 100%" >
            <table-item v-for="(item,index) in tableTheads" :key="index" :itemData="item"></table-item>
        </el-table>

        <!-- 分页 -->
        <pagination v-show="total>0" :autoScroll="false" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="padding: 15px 16px 8px" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import TableItem from './tableItem'
import { arrSlice, sortKeys } from '@/filters'
import { houtaixiazairenwu } from '@Bdc~/api/ajax_model'
export default {
    components:{Pagination, TableItem},
    props:{
         // 模块 item
        sourceItem:{
            type:Object,
            default: () => {}
        },

        // 公共查询
        filterData: {
            type: Object,
            default: () => {}
        },

        // 子查询
        filterSondata: {
            type: Object,
            default: () => {}
        },

        // 数据
        sourceData:{
            type:Object,
            default: () => {
                thead: []
                tbody: []
            }
        }
    },
    data() {
        return {
            // 表格
            originalCaseTable: [], // 排序原始数据
            caseTable: [], // 存放后端一次性返回的所有数据
            handCaseTable: [], // 存放处理假分页后的数据(等距切割)
            tableData: [], // 切割后页面应展示的数据
            tableTheadOptions:[],
            checkboxTitle: [],
            tableTheads: [],

            total: 0,
            listQuery: {
                pageNo: 1,
                pageSize: 10
            },

            downloadLoading: false // 下载
        }
    },

    watch: {
        sourceData(val) {
            // console.log('初始化watch11111', val)
            this.init()
        },

        // 筛选table header
        checkboxTitle(valArr) {
            this.tableTheads = []

            this.$nextTick(() => {
                this.tableTheads = this.tableTheadOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
            })
        }
    },

    computed: {
        // 筛选列表表
        tableList() {
            let caseTable = this.caseTable
            this.total = caseTable.length
            // 将一维数组切割成二维数组
            this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
            this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
            return this.tableData
        },
    },

    mounted() {
        this.$nextTick(() => {
            // console.log('初始化mounted11111')
            this.init()
        })
    },

    methods:{
        // 初始化数据
        init() {
            console.log('初始化22222', this.sourceData)
            this.tableTheadOptions = this.sourceData.thead
            this.checkboxTitle = JSON.parse(JSON.stringify(this.sourceData.thead))

            this.caseTable = this.sourceData.tbody
            this.originalCaseTable = JSON.parse(JSON.stringify(this.sourceData.tbody))
        },

        // 监听排序变化
        handleAgeSortChange(e) {
            // console.log(e)
            if (e.order) {
                const order = e.order == 'descending' ? false : true
                this.caseTable.sort(sortKeys(e.prop, order))
            } else {
                this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
            }
        },

        // 下载
        handleDownload() {

            // console.log(this.sourceItem)
            this.downloadLoading = true

            const headerObj = {
                'header_view_code': this.sourceItem.code,
                'header_time_type': this.sourceItem.timeType
            }

            for (var key in this.filterData) { // 公共查询
                if (this.filterData.hasOwnProperty(key) === true) {
                    headerObj[key] = this.filterData[key];
                }
            }

            // console.log('下载====',headerObj, this.filterSondata)

            houtaixiazairenwu(headerObj,this.filterSondata).then(response => {
                if(response.code == 1) {
                    this.downloadLoading = false
                    this.$message.success("下载任务提交成功，请到下载管理页面查看下载进度")
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .filter-container{
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
    }
    .filterTableHeader{
        margin-right: 10px;
    }

    .checkboxScrollList{
        max-height: 320px;
        overflow-y:auto;
    }
    .checkbox-table-headers {
        ::v-deep .el-checkbox {
            width: 125px;
        }
        ::v-deep .el-checkbox__label{
            width: 120px;
            overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align: middle;
        }
    }

    .grayTableTile{
        ::v-deep.cell {
            position: relative;
            padding: 0 5px !important;
            line-height: 16px;
        }
        ::v-deep.caret-wrapper {
            position: absolute;
            top: -7px;
            right: 0;
        }
    }

</style>
